const stats = [
  { value: "12,000+", label: "收录片源信息" },
  { value: "36 类", label: "覆盖题材分类" },
  { value: "2008→2026", label: "跨越年份区间" },
  { value: "48h", label: "高频资讯更新" },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[640px] w-full flex-col justify-center overflow-hidden md:min-h-[720px]">
      {/* 背景图 */}
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20montage%20scene%20of%20a%20grand%20movie%20theater%20with%20warm%20golden%20spotlights%2C%20deep%20crimson%20velvet%20curtains%20and%20floating%20film%20strips%20and%20light%20beams%2C%20dark%20atmospheric%20artistic%20illustration%2C%20rich%20amber%20and%20burgundy%20tones%2C%20elegant%20cinema%20ambiance%2C%20no%20text&width=1600&height=900&seq=hero-cinema-2026&orientation=landscape"
        alt="吃瓜影院电影观影概念背景图"
        className="absolute inset-0 h-full w-full object-cover object-center"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-50"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>

      <div className="container-x relative z-10 flex w-full flex-col items-start pt-24 md:pt-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs font-semibold tracking-[0.2em] text-white backdrop-blur-sm md:text-sm">
          <i className="ri-clapperboard-fill" aria-hidden="true"></i>
          吃瓜影院 · 你的选片放映室
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-white md:text-6xl md:leading-[1.1]">
          找片不愁，
          <br />
          <span className="text-accent-300">每一部好电影</span>都值得被看见
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/80 md:text-lg">
          这里汇总最新片库、高分佳片、热门题材与观影入口。院线大片、经典片源一网收好，点片名即可轻松选片，陪你找到下一部心头好。
        </p>

        <div className="mt-8 flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center">
          <a
            href="#new"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-sm font-bold whitespace-nowrap text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-play-circle-fill text-lg" aria-hidden="true"></i>
            立即选片
          </a>
          <a
            href="#curated"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 py-3 text-sm font-semibold whitespace-nowrap text-white backdrop-blur-sm transition-colors hover:bg-white/20"
          >
            <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
            浏览编辑精选
          </a>
        </div>

        <p className="mt-6 inline-flex items-center gap-2 text-xs text-white/60">
          <i className="ri-shield-check-line" aria-hidden="true"></i>
          请通过正规院线与授权平台观影，尊重每一份创作
        </p>
      </div>

      {/* 数据条 */}
      <div className="container-x relative z-10 w-full pb-10 md:pb-14">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-white/15 backdrop-blur-md md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center justify-center gap-1 bg-black/25 px-4 py-5 text-center md:py-7">
              <span className="font-heading text-2xl font-black text-accent-300 md:text-3xl">{s.value}</span>
              <span className="text-xs text-white/70 md:text-sm">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}